import { Component, OnInit, inject ,Inject} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router, ActivatedRoute } from '@angular/router';
import { CHAR_PLUS,TUI_IS_MOBILE } from "@taiga-ui/cdk";
import { PhoneNumberUtil } from 'google-libphonenumber';
import { TuiCountryIsoCode } from '@taiga-ui/i18n';
import { AWSLambda } from 'src/app/AWSLambda.service';
import { TUI_COUNTRIES } from '@taiga-ui/kit';
import { Observable } from 'rxjs';
import { BoRolesCheckService } from 'src/app/components/rolesCheck/bo-roles-check.service';

@Component({
  selector: 'app-edit-my-profile',
  templateUrl: './edit-user.component.html',
})
export class BOEditUserComponent implements OnInit {

  _snackBar = inject(MatSnackBar);
  router = inject(Router);
  rolesCheck = inject(BoRolesCheckService);

  canAccess = false;

  clientsPortalId: string = "cliente";
  btbPortalId: string = "btb";
  boPortalId: string = "backoffice";

  adminTransactionsRoleId: string = "adminTransactions";
  adminUsersRoleId: string = "adminUsers";
  adminPromotionsRoleId: string = "adminPromotions";
  adminLogErrorsId: string = "adminLogErrors";

  isNewUser: boolean = false;
  currentUserId: string = '';
  loading: boolean = true;

   constructor(@Inject(TUI_IS_MOBILE)
   public isMobile: boolean,
   @Inject(TUI_COUNTRIES)
  readonly countriesNames$: Observable<Record<TuiCountryIsoCode, string>>,
   private lambda: AWSLambda,
   private route: ActivatedRoute
  ) {

    }
    readonly countries = Object.values(TuiCountryIsoCode);
    countryIsoCode: TuiCountryIsoCode = TuiCountryIsoCode.ES;
    //selectedCountry: TuiCountryIsoCode = TuiCountryIsoCode.ES;
    countryFilter: string = '';
    selectedCountry: TuiCountryIsoCode | null = null;

  createForm: FormGroup = new FormGroup({
    name: new FormControl(''),
    middle_name: new FormControl(''),
    'custom:address': new FormControl(''),
    'custom:country': new FormControl(''),
    email: new FormControl('', [Validators.email]),
    phone_number: new FormControl({ value: '', disabled: true }, [
      Validators.pattern( '^\\+(?:[0-9] ?){6,14}[0-9]$' ),
    ]),
    isPhoneVerified: new FormControl<boolean>(false),

    'custom:ciudad': new FormControl(''),
    'custom:provincia': new FormControl(''),
    'custom:postcode': new FormControl(''),
    'custom:passport': new FormControl(''),
    'custom:Partnercode': new FormControl(''),

    // status
    isEnabled: new FormControl<boolean>({ value: false, disabled: true }),
    isBanned: new FormControl<boolean>(false),
    shouldBeDeleted: new FormControl<boolean>({ value: false, disabled: true }),

    // roles
    isSuperAdmin: new FormControl<boolean>({ value: false, disabled: true }),
    accessClients: new FormControl<boolean>(false),
    accessBTB: new FormControl<boolean>(false),
    accessBO: new FormControl<boolean>(false),

    // btb
    btbBankAccount: new FormControl(''),
    'custom:btbPartnerId': new FormControl(''),

    // bo
    isAdminTransactions: new FormControl<boolean>(false),
    isAdminUser: new FormControl<boolean>(false),
    isAdminPromotion: new FormControl<boolean>(false),
    isAdminLogErrors: new FormControl<boolean>(false),
  });

  async ngOnInit() {
    this.canAccess = await this.rolesCheck.checkAccess();
    if (!this.canAccess) {
      return;
    }

    const { url } = this.router;

    if (url.endsWith('/create')) {
      this.isNewUser = true;
      this.createForm.setControl(
        'phone_number', new FormControl('', [
          Validators.pattern( '^\\+(?:[0-9] ?){6,14}[0-9]$' ),
        ]),
      )
      return;
    }

    try {
      const userToEditSub = this.route.snapshot.paramMap.get('userId');
      this.isNewUser = userToEditSub === 'new';
      this.currentUserId = this.isNewUser ? '' : (userToEditSub || '');
      sessionStorage.setItem('back_url', this.currentUserId ? `/backoffice/users/${this.currentUserId}` : '/backoffice/users');

      if (this.isNewUser) {
        this.createForm.get('phone_number')?.enable();
        this.loading = false;
        return;
      }

      const data = await this.lambda.getLambdaFunction("lambda", "/get/userDetails", {
        queryStringParameters: {
          sub: userToEditSub
        }
      });

      console.log('user data', data);

      const ciudad = data['custom:ciudad'];
      const provincia = data['custom:provincia'];
      const postcode = data['custom:postcode'];
      const passport = data['custom:passport'];
      const phone_number = data['phone_number'];
      const isPhoneVerified = data['phone_number_verified'] === 'true';
      const email = data['email'];
      const partnerCode = data['custom:Partnercode'];

      const middle_name = data['middle_name'];
      const address = data['custom:address'];
      const country = data['custom:country'];

      // btb
      const btbBankAccount = data['btbBankAccount'];
      const btbPartnerId = data['custom:btbPartnerId'];

      const isEnabled = data['Enabled'];
      const isBanned = data['custom:Banned'] === '1';

      // roles
      const isSuperAdmin = data['custom:backofficeSuperAdmin'] === '1';

      const accessClients = data['custom:Portal']?.includes(this.clientsPortalId) ?? false;
      const accessBTB = data['custom:Portal']?.includes(this.btbPortalId) ?? false;
      const accessBO = data['custom:Portal']?.includes(this.boPortalId) ?? false;

      const isAdminUser = data['custom:backofficeRoles']?.includes(this.adminUsersRoleId) ?? false;
      const isAdminPromotion = data['custom:backofficeRoles']?.includes(this.adminPromotionsRoleId) ?? false;
      const isAdminTransactions = data['custom:backofficeRoles']?.includes(this.adminTransactionsRoleId) ?? false;
      const isAdminLogErrors = data['custom:backofficeRoles']?.includes(this.adminLogErrorsId) ?? false;

      if (!country || country === "") {
        if (phone_number) {
          const detectedCountry = this.getCountryIsoCode(phone_number);
          // Si el campo custom:country no ha sido actualizado, asignamos el país detectado
          this.selectedCountry = detectedCountry;
          this.createForm.patchValue({ 'custom:country': detectedCountry });
        }
      } else {
        // Si el país ya está presente, simplemente asignamos el valor
        this.selectedCountry = country as TuiCountryIsoCode;
      }

      this.createForm.patchValue({
        name: data['name'],
        phone_number,
        isPhoneVerified,
        email,

        middle_name,
        'custom:address': address,
        'custom:country': country,
        'custom:provincia': provincia,
        'custom:Partnercode': partnerCode,

        'custom:ciudad': ciudad,
        'custom:postcode': postcode,
        'custom:passport': passport,

        // status
        isEnabled,
        isBanned,
        shouldBeDeleted: false,

        // roles
        isSuperAdmin,
        accessClients,
        accessBTB,
        accessBO,

        // btb
        btbBankAccount,
        'custom:btbPartnerId': btbPartnerId,

        // bo
        isAdminUser,
        isAdminPromotion,
        isAdminTransactions,
        isAdminLogErrors,
      });
      
      this.loading = false;
    } catch (error) {
      console.log('Backoffice - Error getting user:', error);
      this.loading = false;
    }
  }

  async onUpdate() {
    const form = this.createForm;
    const formValue = form.getRawValue();
    console.log(formValue);

    let userToEditSub;
    if (!this.isNewUser) {
      userToEditSub = this.route.snapshot.paramMap.get('userId');

      if (!userToEditSub) {
        this._snackBar.open('No se ha encontrado el usuario', 'Close', {
          duration: 5000,
        });
        this.router.navigate(['/backoffice/users']);
        return;
      }
    }

    let portalsValues = [];
    if (formValue['accessClients']) {
      portalsValues.push(this.clientsPortalId);
    }
    if (formValue['accessBTB']) {
      portalsValues.push(this.btbPortalId);
    }
    if (formValue['accessBO']) {
      portalsValues.push(this.boPortalId);
    }

    let rolesValues = [];
    if (formValue['isAdminUser']) {
      rolesValues.push(this.adminUsersRoleId);
    }
    if (formValue['isAdminPromotion']) {
      rolesValues.push(this.adminPromotionsRoleId);
    }
    if (formValue['isAdminTransactions']) {
      rolesValues.push(this.adminTransactionsRoleId);
    }
    if (formValue['isAdminLogErrors']) {
      rolesValues.push(this.adminLogErrorsId);
    }

    this.lambda.getLambdaFunction(
      "lambda",
      this.isNewUser ? "/user/create" : "/crm/contact/updateProfile",
      {
        queryStringParameters: {
          "sub": this.isNewUser ? undefined : userToEditSub,
          "name": formValue['name'].trim(),
          "middle_name": formValue['middle_name'].trim(),
          "custom:address": formValue['custom:address'].trim(),
          "custom:ciudad": formValue['custom:ciudad'].trim(),
          "custom:provincia": formValue['custom:provincia'].trim(),
          "custom:postcode": formValue['custom:postcode'].trim(),
          "custom:country": formValue['custom:country'].trim(),
          "custom:passport": formValue['custom:passport'].trim(),
          "custom:Partnercode": formValue['custom:Partnercode']?.trim() ?? '',
          "custom:btbPartnerId": formValue['custom:btbPartnerId']?.trim() ?? '',
          "custom:Portal": portalsValues.join(','),
          "custom:backofficeRoles": rolesValues.join(','),
          "email": formValue['email']?.trim() ?? '',
          "phone_number": formValue['phone_number'].trim(),
          "phone_number_verified": formValue['isPhoneVerified'].toString(),
          "custom:Banned": formValue['isBanned'] ? 1 : 0,
          "atributos": JSON.stringify({
            "btbBankAccount": formValue['btbBankAccount']?.trim() ?? '',
          }),
        }
      }
    ).then((result: any) => {
      if(result.ok){
        this._snackBar.open(
          this.isNewUser ? 'The user profile was created successfully.' : 'The user profile was updated successfully.',
          'Close',
          {
            duration: 5000,
          }
        );

        if (this.isNewUser) {
          this.router.navigate(['/backoffice/users'], { replaceUrl: true });
        } else {
          this.router.navigate(['/backoffice/users', this.currentUserId], { replaceUrl: true });
        }
      }
      else
      {
        this._snackBar.open('Failed:'+result.message, 'Close', {
          duration: 5000,
        });
      }
    }).catch((error: any) => {
      this._snackBar.open(
        this.isNewUser ? 'Failed to create the user profile. Please try again.' : 'Failed to update the user profile. Please try again.',
        'Close',
        {
          duration: 5000,
        }
      );
      console.error('Error updating profile:', error);
      return;
    });
  }

  goBack() {
    if (this.currentUserId) {
      this.router.navigate(['/backoffice/users', this.currentUserId]);
    } else {
      this.router.navigate(['/backoffice/users']);
    }
  }

  getCountryIsoCode(value: string) {
    const phoneUtil = PhoneNumberUtil.getInstance();
    const phoneNumber = phoneUtil.parse(CHAR_PLUS + value);
    const region = phoneUtil.getRegionCodeForNumber(phoneNumber);
    if (region !== undefined) {
      return TuiCountryIsoCode[region as TuiCountryIsoCode];
    }
    return TuiCountryIsoCode.ES;
  }

  countryName(code: TuiCountryIsoCode): string {
    return code.replace('_', ' ');
  }

  filteredCountries(
    countries: TuiCountryIsoCode[],
    countriesNames: Record<TuiCountryIsoCode, string>,
    search: string
  ): TuiCountryIsoCode[] {
    if (!search) return countries;
    const lowerSearch = search.toLowerCase();
    return countries.filter(country =>
      countriesNames[country].toLowerCase().includes(lowerSearch)
    );
  }

  protected readonly Object = Object;
}
